export enum TodosActions {
  LoadTodos = "loadTodos",
}
